;(function () {
  angular.module('contrast.filters').filter('safeHighlight', function () {
    function escapeRegexp(queryToEscape) {
      return ('' + queryToEscape).replace(/([.?*+^$[\]\\(){}|-])/g, '\\$1')
    }

    return function (matchItem, query, length) {
      if (!length) {
        length = 2
      }

      if (query && matchItem && query.length >= length) {
        return ('' + _.escape(matchItem)).replace(
          new RegExp(escapeRegexp(query), 'gi'),
          '<span class="ui-select-highlight">$&</span>'
        )
      }

      return _.escape(matchItem)
    }
  })
})()
